import React from 'react';
import styled from 'styled-components';
import FooterComponent from '../components/FooterComponent';

const BasicLayout = ({ children }) => {
  return (
    <>
      <LayoutContainer>
        <MainContent>{children}</MainContent>
      </LayoutContainer>
      <FooterComponent />
    </>
  );
};

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  /* padding: 20px; */

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const MainContent = styled.main`
  flex: 1;
  /* background-color: #f0f0f0; */
  /* padding: 20px; */
  margin-bottom: 20px;

  @media (min-width: 768px) {
    margin-bottom: 0;
    /* margin-right: 20px; */
  }
`;

export default BasicLayout;
